<template>
    <div>
        <v-card-title>
            {{ title }}
            <v-spacer></v-spacer>
            <template v-if="isEmployee">
                <modal-board-members :loading="loading" :company-info="client.companyInfo" :current-board-members="item" :is-new="true" @close-board-success-dialog="refreshAll" :type="type"></modal-board-members>
            </template>
        </v-card-title>
        <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
        <v-card v-if="item" class="mt-4" elevation="0" outlined>
            <data-table-board-members-read :type="type" :company-info="client.companyInfo" :item="item" @refresh-all="refreshAll"></data-table-board-members-read>
        </v-card>
        <div v-else class="text-center mt-4 mb-4"><span style="color: red">{{ $t('corporate.administration.current.empty') }}</span></div>
    </div>
</template>

<script>
import API from '@/api'
import ModalBoardMembers from '@/components/corporate/ModalBoardMembers'
import DataTableBoardMembersRead from '@/components/corporate/DataTableBoardMembersRead'

export default {
    name: 'current-captable',
    props: ['title', 'client', 'type'],
    components: {
        ModalBoardMembers,
        DataTableBoardMembersRead
    },
    data: function () {
        return {
            loading: false,
            item: undefined
        }
    },
    mounted () {
        this.loadData()
    },
    computed: {
        isEmployee: function () {
            return this.$helpers.checkIsEmployee()
        }
    },
    methods: {
        loadData () {
            this.loading = true
            let endpoint = API.EndPoints.getCorporateBoardMembers
            let where = {
                client: { __type: 'Pointer', className: 'Client', objectId: this.$helpers.getCorporateClientId(this.$route.name, 'ClienteSocietarioAdministracao', this.$route.params.id) },
                isCurrent: true,
                type: this.type
            }
            const params = {
                limit: 1,
                skip: 0,
                count: true,
                order: '-createdAt',
                where: JSON.stringify(where)
            }
            new API(endpoint, params).request().then(response => {
                this.item = (response.data.results.length > 0) ? { ...response.data.results[0] } : undefined
                this.loading = false
            }, (e) => {
                this.$helpers.requestError(e)
            })
        },
        refreshAll () {
            this.$emit('refresh-all')
            this.loadData()
        }
    }
}
</script>
